import { testimonials } from "@/mocks/comicData";

export default function Testimonials() {
  return (
    <section id="testimonial" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="mx-auto mb-12 max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
            <i className="ri-chat-3-line" />
            读者口碑
          </span>
          <h2 className="font-heading mt-4 text-3xl text-foreground-950 md:text-4xl">
            读者怎么说
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            入口是否好用、页面打不开时能否快速解决，听听常驻读者的真实反馈。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
          {testimonials.map((t) => (
            <figure
              key={t.name}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-6"
            >
              <div className="flex items-center gap-1 text-accent-500">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${i < t.star ? "ri-star-fill" : "ri-star-line text-foreground-300"}`}
                  />
                ))}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
                “{t.text}”
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                <img
                  src={t.avatar}
                  alt={`${t.name} 头像`}
                  className="h-11 w-11 rounded-full object-cover"
                />
                <div>
                  <p className="text-sm font-bold text-foreground-950">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}